module.exports = __webpack_public_path__ + "img/wobi.d7c2436a.jpg";